<mat-form-field
  [appearance]="appearance()"
  [floatLabel]="!control.value ? 'always' : 'auto'"
  class="w-full"
  [class.danger]="control.invalid && (control.dirty || control.touched)"
>
  @if (showLabel()) {
    <mat-label [attr.id]="id() + '_label'" [attr.for]="id()">{{
      label()
    }}</mat-label>
  }
  @if (showSelectedIcon() && selectedIcon) {
    <mat-icon matPrefix [fontSet]="selectedIconFontSet || 'material-icons'">{{
      selectedIcon
    }}</mat-icon>
  }
  <input
    type="text"
    [placeholder]="placeholder()"
    matInput
    [attr.id]="id()"
    [attr.name]="id()"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-labelledby]="showLabel() && label() ? id() + '_label' : null"
    [attr.aria-controls]="auto.id + '_listbox'"
    [formControl]="control"
    [matAutocomplete]="auto"
  />
  @if (showClearButton() && control.value) {
    <button
      matIconButton
      matSuffix
      type="button"
      [attr.aria-label]="label() ? 'Svuota campo ' + label() : 'Svuota campo'"
      matTooltip="Svuota campo"
      (click)="clearValue($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
  <mat-autocomplete
    [displayWith]="displayFn"
    #auto="matAutocomplete"
    aria-activedescendant="true"
    [id]="auto.id + '_listbox'"
  >
    @for (option of filteredOptions$ | async; track option.id ?? option.name) {
      <mat-option
        [value]="option"
        [disabled]="option?.disabled || isOptionDisabled(option)"
        [class]="{ highlight: option?.isSegretario }"
      >
        @if (option?.icon && !option?.extraIcon) {
          <mat-icon
            [fontSet]="option?.iconFontSet || 'material-icons'"
            [matTooltip]="option?.extraIconLabel"
            [attr.aria-label]="option?.extraIconLabel"
            >{{ option?.icon }}</mat-icon
          >
        }
        @if (option?.extraIcon) {
          <!-- extraIcon, quando presente, è l'icona principale mostrata:
               `icon` resta valorizzato (es. 'home') solo per la business
               logic che lo usa come discriminante altrove. -->
          <mat-icon
            [matTooltip]="option?.extraIconLabel"
            [attr.aria-label]="option?.extraIconLabel"
            >{{ option?.extraIcon }}</mat-icon
          >
        }
        <span class="m-0 p-0">{{ option.name }}</span>
      </mat-option>
    }
    @if ((filteredOptions$ | async)?.length === 0) {
      <mat-option [disabled]="true">
        {{
          emptyMessage() || 'GENERAL.no_results_found' | translate
        }}</mat-option
      >
    }
  </mat-autocomplete>
  <mat-error siatErrorField [control]="control" [label]="label()"></mat-error>
</mat-form-field>
